<app-modal>
    <ng-container title>
        {{ 'FILTER.SAVED_FILTERS.MODAL_TITLE' | translate }}
    </ng-container>
    <ng-container body>
        <input
            type="text"
            [(ngModel)]="filterName"
            [placeholder]="'FILTER.SAVED_FILTERS.NAME_PLACEHOLDER' | translate"
            (keydown.enter)="onSave()"
        />
    </ng-container>
    <ng-container footer>
        <button type="button" (click)="onCancel()">
            {{ 'BUTTONS.CANCEL' | translate }}
        </button>
        <button type="button" class="primary" (click)="onSave()" [disabled]="!filterName.trim()">
            {{ 'BUTTONS.SAVE' | translate }}
        </button>
    </ng-container>
</app-modal>
